import { Button, DiagnosticCopy } from '@krp/ui-kit'

import type { DeliveryView } from '../model/deliveryView'
import './delivery.css'

export interface DeliveryIndicatorProps {
  view: DeliveryView
  /** «Проверить сейчас»: монитор сам не пустит запрос чаще порога. */
  onRefresh?: () => void
  /** Открыть окно «Доставка» (список недоставленного). */
  onDetails?: () => void
  /** Компактный вид для экрана продажи: без подробностей, пока нет отказа или очереди. */
  compact?: boolean
}

/**
 * Индикатор «учтено на сервере» (RP-OWN9). Состояние — значок и слова, цвет только дополняет. Отказ сервера показан целиком,
 * копируется и не исчезает по таймеру: убрать его можно только разбором на сервере. Это диагностика: ни одна кнопка здесь не
 * касается денег и не закрывает и не открывает продажу.
 */
export function DeliveryIndicator({ view, onRefresh, onDetails, compact = false }: DeliveryIndicatorProps) {
  const showDetails = !compact || view.severity === 'problem' || view.severity === 'attention'
  return (
    <section className={`own-delivery own-delivery--${view.severity}`} role={view.kind === 'rejected' ? 'alert' : 'status'} aria-label="Доставка в центральный журнал">
      <p className="own-delivery__head">
        <span className="own-delivery__mark" aria-hidden="true">
          {view.mark}
        </span>
        <strong className="own-delivery__title">{view.title}</strong>
      </p>
      {showDetails && view.lines.map((line) => <p key={line} className="own-delivery__line">{line}</p>)}
      {view.error !== null && (
        <div className="own-delivery__error">
          <p className="own-delivery__error-text">{view.error.text}</p>
          <dl className="own-delivery__facts">
            {view.error.code !== null && (<><dt>Код</dt><dd>{view.error.code}</dd></>)}
            {view.error.status !== null && (<><dt>HTTP-статус</dt><dd>{view.error.status}</dd></>)}
            {view.error.requestId !== null && (<><dt>Номер запроса</dt><dd>{view.error.requestId}</dd></>)}
            {view.error.operationId !== null && (<><dt>Операция</dt><dd>{view.error.operationId}, ревизия {view.error.revision}</dd></>)}
            {view.error.at !== null && (<><dt>Время</dt><dd>{view.error.at}</dd></>)}
          </dl>
          <DiagnosticCopy text={view.error.report} label="Скопировать" />
        </div>
      )}
      <p className="own-delivery__fresh">{view.freshness}</p>
      {(onRefresh !== undefined || onDetails !== undefined) && (
        <div className="own-delivery__actions">
          {onRefresh !== undefined && <Button variant="ghost" onClick={onRefresh}>Проверить</Button>}
          {onDetails !== undefined && <Button variant="ghost" onClick={onDetails}>Что не доставлено…</Button>}
        </div>
      )}
    </section>
  )
}
